import styled from "styled-components";
import { Link } from "react-router-dom";
import BASE_API_URL from "../apis/index";

export default function CompanyCard({ compData, linkType }) {
  const companyTypes = JSON.parse(compData.company_types || "[]");
  const companyImages = JSON.parse(compData.company_images || "[]");

  const linkHref =
    linkType === "user"
      ? `/user-company-details?compId=${compData.id}`
      : `/company-details?compId=${compData.id}`;

  const imageSrc =
    companyImages.length > 0
      ? `${BASE_API_URL}/uploads/user_comp_docs/${companyImages[0]}`
      : "/placeholder-image.jpg";

  return (
    <Card>
      <CardImage
        src={imageSrc}
        alt={compData.company_name}
        loading="lazy"
      />

      <CardContent>
        <HeaderRow>
          <LogoWrapper>
            <img
              src={`${BASE_API_URL}/uploads/user_comp_docs/${compData.company_logo}`}
              alt="Company Logo"
            />
          </LogoWrapper>

          <CompanyName>{compData.company_name}</CompanyName>
        </HeaderRow>

        <TypesWrapper>
          {companyTypes.map((type, idx) => (
            <TypeChip key={idx}>{type}</TypeChip>
          ))}
        </TypesWrapper>

        <ViewButton to={linkHref}>View Details</ViewButton>
      </CardContent>
    </Card>
  );
}

const Card = styled.div`
  width: 100%;
  min-height: 480px;
  background: var(--bg-color);
  border-radius: 12px;
  border: 2px solid rgba(210, 160, 100, 0.16);
  box-shadow: 0 2px 8px rgba(210, 160, 100, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: 0.3s ease;
  transform: translateZ(0);

  &:hover {
    box-shadow: 0 6px 20px rgba(210, 160, 100, 0.2);
    transform: translateY(-4px);
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
  backface-visibility: hidden;
`;

const CardContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const HeaderRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 10px;
`;

const LogoWrapper = styled.div`
  width: 55px;
  height: 55px;
  background: white;
  border-radius: 6px;
  padding: 5px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const CompanyName = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  color: #43141d;
`;

const TypesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 20px;
`;

const TypeChip = styled.div`
  background: #fff1de;
  color: #f89622;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 6px;
`;

const ViewButton = styled(Link)`
  margin-top: auto;
  align-self: flex-start;
  border: 1px solid var(--secondary-color);
  padding: 8px 16px;
  font-size: 0.8rem;
  text-decoration: none;
  color: var(--secondary-color);
  border-radius: 6px;
  transition: 0.3s ease;

  &:hover {
    background: var(--secondary-color);
    color: white;
  }
`;